



















































































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FormButton extends Vue {
  @Prop() readonly name!: string;

  @Prop({ default: 'submit' }) readonly type!: string;

  @Prop({ default: false }) readonly loading!: boolean;

  @Prop({ default: false }) readonly success!: boolean;

  @Prop({ default: false }) readonly disabled!: boolean;

  get displayText() {
    if (this.loading) {
      if (!this.$te(`${this.name}.buttons.loading`)) {
        return this.$t(`forms.buttons.loading`);
      }
      return this.$t(`${this.name}.buttons.loading`);
    }

    if (this.success) {
      if (!this.$te(`${this.name}.buttons.success`)) {
        return this.$t(`forms.buttons.success`);
      }
      return this.$t(`${this.name}.buttons.success`);
    }

    if (!this.$te(`${this.name}.buttons.submit`)) {
      return this.$t(`forms.buttons.submit`);
    }
    return this.$t(`${this.name}.buttons.submit`);
  }
}
